import { CheckboxOption } from 'shared/common/ConvertToCheckboxOptions'
import { payments } from 'shared/model/commonConstants'
import { PaymentMethod } from 'shared/types/Common'

import { useEffect, useState } from 'react'

import { useGetPaymentMethodsQuery } from 'modules/Orders/services/ordersApi'

interface Props {
  isCreateOrder: boolean
}
export const usePayments = ({ isCreateOrder }: Props) => {
  const { data: paymentMethods } = useGetPaymentMethodsQuery()
  const [paymentOptions, setPaymentOptions] = useState<CheckboxOption[]>([])

  useEffect(() => {
    if (paymentMethods?.success) {
      setPaymentOptions(
        paymentMethods.result
          .map((paymentMethod) => {
            const paymentMethodName = paymentMethod.name as PaymentMethod
            if (isCreateOrder) {
              return {
                label: payments[paymentMethodName],
                value: paymentMethodName !== 'CARD' ? paymentMethodName : '',
              }
            }
            return {
              label: payments[paymentMethodName],
              value: paymentMethodName,
            }
          })
          .filter((paymentMethod) => paymentMethod.value !== ''),
      )
    }
  }, [paymentMethods])

  return { paymentOptions }
}
